import React from 'react';
import { useSelector } from 'react-redux';
import ContactFooter from '../../../pages/homes/footer/contact';
const Footer = () => {
  const metaData = useSelector((state) => state.settingAccount.metaData);
  return (
    <footer className="custom-footer">
      <div className="footer-bg-color">
        {metaData?.cmsFooter && <ContactFooter />}
      </div>
    </footer>
  );
};

export default Footer;
